<template>
    <div style="width:100%">
        <v-container fluid grid-list-md>
            <v-layout row wrap>
                <v-flex xs12>
                    <v-card-title class="blue-grey lighten-1 text-white font-weight-bold">My Information</v-card-title>
                    <v-card>
                        <v-list>
                            <v-list-item ripple @click="loadProfile()">
                                Manage My Profile
                            </v-list-item>
                        </v-list>
                    </v-card>
                </v-flex>
                <v-flex xs12 md4 v-if="$permissionHolder.hasPermission('USER')">
                    <v-card-title class="blue-grey lighten-1 text-white font-weight-bold">Users</v-card-title>
                    <v-card>
                        <v-list>
                            <v-list-item v-if="$permissionHolder.hasPermission('USER.CREATE')" ripple @click="go('CreateUser')">
                                Create New User
                            </v-list-item>
                            <v-list-item v-if="$permissionHolder.hasPermission('USER')" ripple @click="go('Users')">
                                Search Users
                            </v-list-item>
                        </v-list>
                    </v-card>
                </v-flex>
                <v-flex xs12 md4 v-if="$permissionHolder.hasPermission('ORGANIZATION')">
                    <v-card-title class="blue-grey lighten-1 text-white font-weight-bold">Organizations</v-card-title>
                    <v-card>
                        <v-list>
                            <v-list-item v-if="$permissionHolder.hasPermission('ORGANIZATION.CREATE')" ripple @click="go('CreateOrganization')">
                                Create New Organization
                            </v-list-item>
                            <v-list-item v-if="$permissionHolder.hasPermission('ORGANIZATION')" ripple @click="go('Organizations')">
                                Search Organizations
                            </v-list-item>
                        </v-list>
                    </v-card>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12 md4 v-if="$permissionHolder.hasPermission('GLOBAL_ADMIN')">
                    <v-card-title class="blue-grey lighten-1 text-white font-weight-bold">CAD Configurations</v-card-title>
                    <v-card>
                        <v-list>
                            <v-list-item @click="go('CreateCadConfiguration')">
                                Create New CAD Configuration
                            </v-list-item>
                            <v-list-item @click="go('CadConfigurations')">
                                Search CAD Configurations
                            </v-list-item>
                        </v-list>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    export default {
        name : 'Home',
        data() {
            return {
            }
        },
        methods : {
            go(id) {
                this.$router.push({name: id});
            },
            loadProfile() {
                this.$router.push({path: '/user-profile'});
            }
        }
    }
</script>

<style>

</style>